module.exports = __webpack_public_path__ + "img/8.dbf9adef.png";